import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterIdentifierTypes',
})
export class FilterIdentifierTypesPipe implements PipeTransform {
  transform(
    allIdentifiers: { displayValue: string; id: string }[],
    selectedIdentifiers: { type: string; code: string }[]
  ): any[] {
    return (allIdentifiers || []).filter(
      (identifier) =>
        !(selectedIdentifiers || []).some(
          (selectedIdentifier) => selectedIdentifier.type === identifier.id
        )
    );
  }
}
